import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      padding: '10% 10px',
      backgroundSize: 'cover',
      backgroundColor: theme.mode === 'dark'
        ? '#605f5f'
        : '#b7b7b9',
      backgroundImage: 'url("/images/home2.png")',
      backgroundPosition: 'bottom',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      overflow: 'hidden',

      '&:before': {
        content: '""',
        position: 'absolute',
        background: theme.mode === 'dark'
          ? '#00000091'
          : 'radial-gradient(circle, rgb(255 255 255) 0%, rgb(0 0 0 / 0%) 100%)',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0
      }
    },

    heroContent: {
      position: 'relative',
      zIndex: 2
    },
    separator: {
      margin: '30px auto !important'
    },
    title: {
      fontSize: '5rem  !important',
      fontWeight: '600 !important',
      lineHeight: '1 !important',
      letterSpacing: '-7px !important',
      fontFamily: '"M PLUS 1 Code", sans-serif !important'

    },
    subtitle: {
      color: theme.mode === 'dark' ? '#bebaba' : '#8b8b8b',
      fontSize: '2rem  !important',
      fontWeight: '600 !important',
      lineHeight: '1 !important'

    }
  }
)

const PREFIX = 'HeroStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const HeroStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    myClass[`&.${classes.root}`] = {
      ...styles.root
    }
    myClass[`& .${classes[key]}`] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  HeroStyle
}
